
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary, { TimeTrackerErrorFallback } from "./components/ErrorBoundary";
import Index from "./pages/Index";

import Dashboard from "./pages/Dashboard";
import WeeklyTimesheet from "./pages/WeeklyTimesheet";
import Manager from "./pages/Manager";
import Profile from "./pages/Profile";
import EmployeeManagement from "./pages/EmployeeManagement";
import UsersListPage from "./pages/UsersList";
import WeeklyReport from "./pages/WeeklyReport";
import MonthlyReport from "./pages/MonthlyReport";
import ProjectManagement from "./pages/ProjectManagement";
import NotFound from "./pages/NotFound";
import TimesheetsPage from "./pages/Timesheets";
// Modules de migration retirés
import AuthGuard from "./components/Layout/AuthGuard";
import PinAuthGuard from "./components/Layout/PinAuthGuard";
import LoginPin from "./pages/LoginPin";
import AdminImportProjetsShifts from "./pages/AdminImportProjetsShifts";

// Configuration React Query avec retry et cache optimisé
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 1,
      retryDelay: 1000,
    },
  },
});

const App = () => {
  return (
    <ErrorBoundary fallback={TimeTrackerErrorFallback}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index />} />

              <Route path="/login" element={<LoginPin />} />
              <Route path="/dashboard" element={
                <AuthGuard>
                  <Dashboard />
                </AuthGuard>
              } />
              <Route path="/weekly" element={
                <AuthGuard>
                  <WeeklyTimesheet />
                </AuthGuard>
              } />
              <Route path="/manager" element={
                <AuthGuard>
                  <Manager />
                </AuthGuard>
              } />
              <Route path="/profile" element={
                <AuthGuard>
                  <Profile />
                </AuthGuard>
              } />
              <Route path="/employees" element={
                <AuthGuard>
                  <EmployeeManagement />
                </AuthGuard>
              } />
              <Route path="/projects" element={
                <AuthGuard>
                  <ProjectManagement />
                </AuthGuard>
              } />
              <Route path="/weekly-report" element={
                <AuthGuard>
                  <WeeklyReport />
                </AuthGuard>
              } />
              <Route path="/monthly-report" element={
                <AuthGuard>
                  <MonthlyReport />
                </AuthGuard>
              } />
              <Route path="/timesheets" element={
                <AuthGuard>
                  <TimesheetsPage />
                </AuthGuard>
              } />
              <Route path="/admin/import-projets-shifts" element={
                <AuthGuard>
                  <AdminImportProjetsShifts />
                </AuthGuard>
              } />
              {/* Routes de migration retirées */}
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};

export default App;
